import { useLocation } from 'react-router-dom';

import { useNavigate } from 'react-router';

export const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const getQueryParam = (key: string): string | null => {
    return searchParams.get(key);
  };

  const setQueryParam = (key: string, value: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set(key, value);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  const deleteQueryParam = (key: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.delete(key);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  const getAllQueryParams = (): Record<string, string> => {
    const params: Record<string, string> = {};
    searchParams.forEach((value: string, key: string) => {
      params[key] = value;
    });
    return params;
  };

  return {
    getQueryParam,
    setQueryParam,
    deleteQueryParam,
    getAllQueryParams,
    searchParams,
  };
};
